import { IonButton, IonCard, IonPopover, IonCardContent, IonCardHeader, IonCardTitle, IonCol, IonContent, IonGrid, IonPage, IonRow, IonText, useIonViewWillLeave } from '@ionic/react';
import { useEffect, useRef, useState } from 'react';
import { useHistory, useLocation } from 'react-router';
import Footer from '../../components/Footer';
import { OptionPages } from '../../models/apiModels';
import { User } from '../../models/data';
import { translation } from '../../models/translation';
import { fetchOptions } from '../../services/options_service';

import './DonateHome.scss';
interface DonateHomeProps {
  user: User | null

}

const Page: React.FC<DonateHomeProps> = ({ user }) => {


  const siteText = translation();
  const lan = translation().lan
  const history = useHistory()
  const lanAlt = siteText.lan.replace("/", "")
  const pathName = useLocation().pathname;

  const isAccountPage = () => {
    if (pathName.indexOf('account') < 0) return false;
    return true
  }
  const [siteOptions, setSiteOptions] = useState<OptionPages>();

  const popover = useRef<HTMLIonPopoverElement>(null);
  const [popoverOpen, setPopoverOpen] = useState(false);

  const openPopover = (e: any,method:any) => {
    setAttemptMethod(method)
    popover.current!.event = e;
    setPopoverOpen(true);
  };

  useIonViewWillLeave(()=>{
    setPopoverOpen(false);

})

  const goToDonatePage = (action: any) => {
    if (action === 'direct') {
      history.push(`${lan}/account/donate_direct_to_org_v2`)
      return

    }
    if (action === 'fundraise') {
      history.push(`${lan}/fundraise`)
      return
    }
    if (action === 'credit') {
      history.push(`${lan}/account/credit`)
      return
    }
  }

  const [attemptMethod,setAttemptMethod]=useState('');
  const loginFirst=()=>{
    if(attemptMethod==="credit"){
      history.push({pathname:`${lan}/signin`,state:{destination:`/account/credit`}})
    }else if(attemptMethod==="direct"){
      history.push({pathname:`${lan}/signin`,state:{destination:`/account/donate_direct_to_org_v2`}})
    }else{
      history.push({pathname:`${lan}/signin`,state:{destination:`/account/donate_direct_to_org_v2`}})

    }
  }
  useEffect(() => {
    getOptions()
  }, [])

  const getOptions = async () => {
    let resp: any = await fetchOptions();
    if (!resp.error) {
      let options: OptionPages = resp.message;
      setSiteOptions(options);
    }
  }

  return (
    <IonPage className="viewContainer">
      <IonContent className='ion-padding'>
        <IonGrid className={!isAccountPage() ? 'sw_sp_md' : 'accountSectionSpacingBottom'}>
          <IonRow>
            {siteOptions?.acf && <IonCol offsetSm='1' sizeSm='10' className='ion-padding'>
              {lanAlt === "en" && <>
                         
                <h1>+{siteOptions?.acf.donate_page_headings_description.en.heading ?? siteText.donateTitle}</h1>
                <p dangerouslySetInnerHTML={{ __html: siteOptions?.acf.donate_page_headings_description.en.description ?? '' }}></p>
              </>}
              {lanAlt === "fr" && <>
                <h1>+{siteOptions?.acf.donate_page_headings_description.fr.heading ?? siteText.donateTitle}</h1>
                <p dangerouslySetInnerHTML={{ __html: siteOptions?.acf.donate_page_headings_description.fr.description ?? '' }}></p>
              </>}
              {lanAlt === "de" && <>
                <h1>+{siteOptions?.acf.donate_page_headings_description.de.heading ?? siteText.donateTitle}</h1>
                <p dangerouslySetInnerHTML={{ __html: siteOptions?.acf.donate_page_headings_description.de.description ?? '' }}></p>
              </>}
            </IonCol>}
          </IonRow>
          <IonRow className='donatePageCards'>
            <IonCol offsetMd='1' sizeMd="10">
              <IonRow>
                <IonCol sizeXs='12' sizeSm='4' className='ion-text-center '>
                <IonCard className='donateButtonCard' type='button' onClick={e => !user ? openPopover(e,'direct') : goToDonatePage('direct')}  style={{  backgroundImage: `url(${siteOptions?.acf.donate_page_images.donate_image})` }}>

                    <IonCardContent className='buttonCardInner'>
                        <IonText className='h4' color='light'>
                          {siteText.donateDirectGroupTitle}

                        </IonText>
                    </IonCardContent>
                  </IonCard>
                </IonCol>
                <IonCol sizeXs='12' sizeSm='4' className='ion-text-center '>
                  <IonCard className='donateButtonCard' onClick={e => !user ? openPopover(e,'credit') : goToDonatePage('credit')} type='button' style={{ backgroundImage:`url(${siteOptions?.acf.donate_page_images.credit_image})`}} >
                    
                    <IonCardContent className='buttonCardInner'>
                        <IonText className='h4' color="light">
                          {siteText.donateLoadGroupTitle}
                        </IonText>
                     
                    </IonCardContent>
                  </IonCard>

                </IonCol>
                <IonCol sizeXs='12' sizeSm='4' className='ion-text-center '>
                  <IonCard className='donateButtonCard' type='button' onClick={()=>+goToDonatePage('fundraise')} style={{backgroundImage:`url(${siteOptions?.acf.donate_page_images.fundraise_image})` }} >

                    <IonCardContent className='buttonCardInner'>
                        <IonText className='h4' color='light'>
                          {siteText.donateFundraiseGroupTitle}
                        </IonText>
                      
                    </IonCardContent>
                  </IonCard>
                </IonCol>


              </IonRow>
            </IonCol>
          </IonRow>
          <IonPopover ref={popover} isOpen={popoverOpen} onDidDismiss={() => setPopoverOpen(false)}>
            <IonContent class="ion-padding">
              <p>{siteText.loginPromtMessage}</p>
              <IonButton onClick={loginFirst} expand='block'><IonText>{siteText.siteLoginBtnTxt}</IonText></IonButton>
              <IonButton routerLink={`${lan}/signup`} style={{ textTransform: 'none  ' }} size='small' color="secondary" fill='clear'>{siteText.loginNoAccount}</IonButton>
            </IonContent>
          </IonPopover>
        </IonGrid>
        <Footer></Footer>
      </IonContent>
    </IonPage>
  );
};

export default Page;
